class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    console.log(parsedState.sections)
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => { 
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

getSectionInnerHTML(html, selector = '.shopify-section') {
  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const element = parsed.querySelector(selector);
  if (!element) return '';

  // Solo para el cart-icon-bubble
  if (element.id === 'shopify-section-cart-icon-bubble') {
    // Reemplazar svg por img
    const svgWrapper = element.querySelector('.svg-wrapper');
    if (svgWrapper) {
      const img = document.createElement('img');
      img.width = 50;
      img.src = 'https://cdn.shopify.com/s/files/1/0715/3713/1657/files/Untitled-8-04_eff0d293-a969-4fc4-86f4-faeb09591721.png?v=1755561537';
      img.alt = 'cart';
      svgWrapper.replaceWith(img);
    }

    // Actualizar el bubble en la utility-bar
    const utilityBubble = document.querySelector('.utility-bar .cart-count-bubble');
    if (utilityBubble) {
      // Remover clases de ocultamiento
      utilityBubble.classList.remove('hide', 'hide-2');

      // Obtener número y texto accesible desde la sección renderizada
      const countSpan = element.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      const visuallyHiddenSpan = element.querySelector('.cart-count-bubble .visually-hidden');

      const count = countSpan ? countSpan.textContent : '0';
      const visuallyHidden = visuallyHiddenSpan ? visuallyHiddenSpan.textContent : '0 items';

      // Actualizar contenido del bubble
      utilityBubble.querySelector('span[aria-hidden="true"]').textContent = count;
      utilityBubble.querySelector('.visually-hidden').textContent = visuallyHidden;

      // Mostrar bubble aunque sea 0
      utilityBubble.style.display = 'flex';
    }
  }

  return element.innerHTML;
}



  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
